'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formFieldGroups"];
import I18n from 'I18n';
import { getTemplates } from 'FormsUI/api/Templates';
import PortalIdParser from 'PortalIdParser';
import { buildForm } from 'FormsUI/actions/FormCreation';
import { getDefaultCopyForLegalConsent } from 'FormsUI/actions/LegalConsent';
import { getRequestState as getTemplateRequestState } from 'FormsUI/selectors/Templates';
import { getDefaultFormName } from 'FormsUI/utils/FormNameUtils';
import { TemplateNames } from 'FormsUI/constants/Templates';
function createAction(name) {
  return `@@templates/${name}`;
}
export const REQUEST_TEMPLATES = createAction('REQUEST_TEMPLATES');
export const SUCCEEDED_GETTING_TEMPLATES = createAction('SUCCEEDED_GETTING_TEMPLATES');
export const FAILED_GETTING_TEMPLATES = createAction('FAILED_GETTING_TEMPLATES');
export const RECEIVE_TEMPLATES = createAction('RECEIVE_TEMPLATES');
function formatTemplates(templates = [], getState) {
  const portalId = PortalIdParser.get();
  const baseForm = buildForm(getState);
  const baseFormForTemplates = _objectWithoutPropertiesLoose(baseForm, _excluded);
  const formattedTemplates = templates.map(template => {
    return Object.assign({}, template, {
      definition: Object.assign({}, template.definition, Object.assign({}, baseFormForTemplates, {
        name: getDefaultFormName(template.name),
        portalId,
        guid: template.name
      }, template.name === TemplateNames.PAYMENT ? {
        submitText: I18n.text('defaultForm.continueToPayment')
      } : {}))
    });
  });
  return [{
    name: TemplateNames.BLANK,
    definition: Object.assign({}, baseForm, {
      name: undefined,
      portalId,
      guid: 'blank'
    })
  }, ...formattedTemplates];
}
function requestTemplates() {
  return {
    type: REQUEST_TEMPLATES
  };
}
function succeededGettingTemplates() {
  return {
    type: SUCCEEDED_GETTING_TEMPLATES
  };
}
function failGettingTemplates() {
  return {
    type: FAILED_GETTING_TEMPLATES
  };
}
function receiveTemplates(templates, getState) {
  const formattedTemplates = formatTemplates(templates, getState);
  return {
    type: RECEIVE_TEMPLATES,
    payload: formattedTemplates
  };
}
export function fetchTemplates() {
  return (dispatch, getState) => {
    const state = getState();
    const templateRequestState = getTemplateRequestState(state);
    if (!templateRequestState.shouldBeRequested()) {
      return Promise.resolve();
    }
    dispatch(requestTemplates());
    Promise.all([getTemplates(), dispatch(getDefaultCopyForLegalConsent())]).then(([templates]) => {
      dispatch(succeededGettingTemplates());
      dispatch(receiveTemplates(templates, getState));
    }, () => {
      dispatch(failGettingTemplates());
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  };
}